import { render, staticRenderFns } from "./caidan.vue?vue&type=template&id=28720afb&scoped=true"
import script from "./caidan.vue?vue&type=script&lang=js"
export * from "./caidan.vue?vue&type=script&lang=js"
import style0 from "./caidan.vue?vue&type=style&index=0&id=28720afb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28720afb",
  null
  
)

export default component.exports